module.exports = __webpack_public_path__ + "img/score-icon-9.9b307532.png";